package com.arena_web.data.api

import com.arena_web.data.dto.*
import com.arena_web.data.http.ApiResponse
import com.arena_web.data.http.apiDelete
import com.arena_web.data.http.apiGet
import com.arena_web.data.http.apiPost
import com.arena_web.data.http.apiPut
import io.ktor.client.*

class TeamApi(private val client: HttpClient) {

    suspend fun createTeam(request: CreateTeamRequest): ApiResponse<TeamWithMembersDto> {
        return client.apiPost("v1/teams", request)
    }

    suspend fun getMyTeams(): ApiResponse<List<TeamDto>> {
        return client.apiGet("v1/teams/me")
    }

    suspend fun getTeam(teamId: String): ApiResponse<TeamWithMembersDto> {
        return client.apiGet("v1/teams/$teamId")
    }

    suspend fun updateTeam(teamId: String, request: UpdateTeamRequest): ApiResponse<TeamWithMembersDto> {
        return client.apiPut("v1/teams/$teamId", request)
    }

    suspend fun deleteTeam(teamId: String): ApiResponse<Unit> {
        return client.apiDelete("v1/teams/$teamId")
    }

    suspend fun addMember(teamId: String, request: AddTeamMemberRequest): ApiResponse<Unit> {
        return client.apiPost("v1/teams/$teamId/members", request)
    }

    suspend fun removeMember(teamId: String, userId: String): ApiResponse<Unit> {
        return client.apiDelete("v1/teams/$teamId/members/$userId")
    }

    suspend fun updateMemberRoles(
        teamId: String,
        userId: String,
        request: UpdateTeamMemberRolesRequest
    ): ApiResponse<Unit> {
        return client.apiPut("v1/teams/$teamId/members/$userId/role", request)
    }

    suspend fun getMatches(teamId: String): ApiResponse<List<TeamMatchDto>> {
        return client.apiGet("v1/teams/$teamId/matches")
    }

    suspend fun getChart(teamId: String, params: Map<String, String> = emptyMap()): ApiResponse<StatsChartDto> {
        return client.apiGet("v1/teams/$teamId/chart", params)
    }

    suspend fun searchTeams(query: String, sportId: String? = null): ApiResponse<List<TeamDto>> {
        val params = buildMap {
            put("query", query)
            if (sportId != null) put("sportId", sportId)
        }
        return client.apiGet("v1/teams/search", params)
    }
}
